import { useResizeObserver } from '@folklore/hooks';
import classNames from 'classnames';

import styles from '../../styles/animations/remax/divider.module.css';

import downArrow from '../../assets/img/animations/remax/divider-arrow.svg';

type DividerProps = {
    value?: string | null;
    anchor?: string | null;
    className?: string | null;
};

function Divider({ value, anchor, className }: DividerProps) {
    const {
        entry: { contentRect: itemRect = null },
        ref: itemRef,
    } = useResizeObserver();
    const { width: itemWidth = null } = itemRect || {};

    const {
        entry: { contentRect: containerRect = null },
        ref: containerRef,
    } = useResizeObserver();
    const { width: containerWidth = null } = containerRect || {};

    const repeatCount =
        containerWidth === null || itemWidth === null ? 1 : Math.floor(containerWidth / itemWidth);

    return (
        <div
            id={anchor}
            ref={containerRef}
            className={classNames(styles.container, 'divider', className)}
        >
            {Array.from(Array(repeatCount).keys()).map((_, index) => (
                <div
                    className={styles.value}
                    ref={index === 0 ? itemRef : null}
                    key={`divider-item-${index}`}
                >
                    <span>{value}</span>
                    <img className={styles.separator} src={downArrow} alt="" />
                </div>
            ))}
        </div>
    );
}

export default Divider;
